import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import logo from "../img/simples_assim_logo.png"
import slide1 from "../img/banner_slide_1.jpg"
import slide2 from "../img/banner_slide_2.jpg"


// import ReactGA from 'react-ga'

class Home extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      menu: false
    }
  }
  
  componentDidMount () {
    // ReactGA.initialize('UA-55278565-1')
    // ReactGA.pageview('/home')
  }

  toggleMenu = () => {
    let state = this.state.menu ? false : true

    this.setState({menu: state})
  }

  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: 0,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
    }

    return (
      <section id="home" className="home">
        <div className="navControl">
          <a className="menuToggle" href="#" onClick={(e)=> { e.preventDefault(); this.toggleMenu()}}>
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p>Menu</p>
          </a>
          <nav className={this.state.menu ? "menu on" : "menu"}>
            <Link smooth to="/#produtos">
              <label>produtos</label>
              <span></span>
            </Link>
            <Link smooth to="/#porque">
              <label>por que Tetra Pak?</label>
              <span></span>
            </Link>
            <Link smooth to="/#contato">
              <label>contato</label>
              <span></span>
            </Link>
          </nav>
          <div className="logo">
            <img src={logo} alt="simples assim" />
          </div>
        </div>
        <div className="mainBanner">
          <Slider {...settings} className="bannerSlider">
            <div className="slide slide1">
              <div style={{backgroundImage: `url(${slide1})`}}></div>
            </div>
            <div className="slide slide2">
              <div style={{backgroundImage: `url(${slide2})`}}></div>
            </div>
          </Slider>
        </div>
        
      </section>
    )
  }
}

export default Home